export const PAYMENT_SOURCE = {
  B2B: "B2B",
  C2B: "C2B"
};

export const PAYMENT_SOURCE_OPTIONS = [
  { label: "B2B", value: PAYMENT_SOURCE.B2B },
  { label: "C2B", value: PAYMENT_SOURCE.C2B }
];

export const PAYMENT_STATUS = {
  ACTION_REQUIRED: "ACTION_REQUIRED",
  CREATED: "CREATED",
  PROCESSING: "PROCESSING",
  APPROVED: "APPROVED",
  FAILED: "FAILED",
  SUCCESS: "SUCCESS"
};

export const PAYMENT_STATUS_OPTIONS = [
  { label: "Action Required", value: PAYMENT_STATUS.ACTION_REQUIRED },
  { label: "Created", value: PAYMENT_STATUS.CREATED },
  { label: "Processing", value: PAYMENT_STATUS.PROCESSING },
  { label: "Approved", value: PAYMENT_STATUS.APPROVED },
  { label: "Failed", value: PAYMENT_STATUS.FAILED },
  { label: "Success", value: PAYMENT_STATUS.SUCCESS }
];

export const PAYMENT_STATUS_PILL = {
  [PAYMENT_STATUS.ACTION_REQUIRED]: { title: "Action Required", backGroundColor: "gold", textColor: "#7a4e00" },
  [PAYMENT_STATUS.CREATED]: { title: "Created", backGroundColor: "default", textColor: "#5B5B5B" },
  [PAYMENT_STATUS.PROCESSING]: { title: "Processing", backGroundColor: "blue", textColor: "#003a8c" },
  [PAYMENT_STATUS.APPROVED]: { title: "Approved", backGroundColor: "geekblue", textColor: "#10239e" },
  [PAYMENT_STATUS.FAILED]: { title: "Failed", backGroundColor: "red", textColor: "#a8071a" },
  [PAYMENT_STATUS.SUCCESS]: { title: "Success", backGroundColor: "green", textColor: "#135200" }
};

export const PAYMENT_ACTION_TYPE = {
  EDIT_PAYMENT_FORM: "EDIT_PAYMENT_FORM",
  RETRIGGER_PAYMENT: "RETRIGGER_PAYMENT",
  VIEW_DETAILS: "VIEW_DETAILS"
};

export const GATEWAY_OPTIONS = [{ label: "Citi Bank", value: "CITI_BANK" }];

export const DEFAULT_PAGE_SIZE = 20;
export const PAGE_SIZE_OPTIONS = [20, 40, 60];
